export const ENTITY_TYPE = {
  LINK: 'LINK',
  IMAGE: 'IMAGE',
  EMBED: 'embed',
  BUTTON: 'BUTTON',
};
